(() => {
  if (window.__titanFastCheckout) return;
  window.__titanFastCheckout = true;

  const variants = {};
  let lastCard = null;

  // Precargar los IDs de producto para no esperar al comprar
  const loadVariants = () =>
    fetch('/products.json?limit=250')
      .then((r) => r.json())
      .then((d) => (d.products || []).forEach((p) => {
        const v = p.variants && p.variants[0];
        if (v) variants[p.handle] = { id: v.id, available: v.available !== false };
      }))
      .catch(() => {});
  const ready = loadVariants();

  document.addEventListener('click', (e) => {
    const c = e.target.closest && e.target.closest('.tlf2-card[data-handle]');
    if (c) lastCard = c;
  }, true);

  function overlay(card) {
    let o = document.getElementById('titan-go');
    if (!o) {
      o = document.createElement('div');
      o.id = 'titan-go';
      o.setAttribute('role', 'status');
      o.innerHTML =
        '<div class="tg-stage"><div class="tg-ring"></div><img class="tg-item" alt=""><div class="tg-cube">' +
        '<span></span><span></span><span></span><span></span><span></span><span></span></div></div>' +
        '<p class="tg-title">Abriendo pago seguro</p><p class="tg-sub"></p>';
      document.body.appendChild(o);
    }
    const img = o.querySelector('.tg-item');
    const src = card && (card.dataset.img || (card.querySelector('.tlf2-art img') || {}).src);
    img.hidden = !src;
    if (src) img.src = src;
    o.querySelector('.tg-sub').textContent = card ? card.dataset.fruit + ' · $' + card.dataset.mxn + ' MXN' : '';
    requestAnimationFrame(() => o.classList.add('on'));
    return o;
  }

  function hideOverlay() {
    const o = document.getElementById('titan-go');
    if (o) o.classList.remove('on');
  }

  function post(variantId, card, user) {
    const f = document.createElement('form');
    f.method = 'post';
    f.action = '/cart/add';
    f.style.display = 'none';
    const add = (n, v) => {
      const i = document.createElement('input');
      i.type = 'hidden';
      i.name = n;
      i.value = v;
      f.appendChild(i);
    };
    add('id', variantId);
    add('quantity', '1');
    add('properties[Usuario exacto de Roblox]', user);
    add('properties[Artículo seleccionado]', card.dataset.fruit);
    add('properties[Método de entrega]', card.dataset.method === 'trade' ? 'Intercambio dentro del juego' : 'Gifting manual');
    add('return_to', '/checkout');
    document.body.appendChild(f);
    f.submit();
  }

  // Reemplaza el "Comprar ahora" original por uno de un solo paso
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest && e.target.closest('#tlf2-modal .tlf2-checkout');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    const modal = document.getElementById('tlf2-modal');
    const status = modal.querySelector('.tlf2-status');
    const input = modal.querySelector('#tlf2-username');
    const confirm = modal.querySelector('#tlf2-confirm');
    const card = lastCard;
    if (!card) return;
    const user = (input.value || '').trim();
    if (user.length < 3) { status.textContent = 'Escribe un usuario de Roblox válido.'; input.focus(); return; }
    if (!confirm.checked) { status.textContent = 'Confirma que el usuario es correcto.'; return; }

    btn.disabled = true;
    btn.classList.add('tg-busy');
    btn.textContent = 'Abriendo pago…';
    status.textContent = '';
    overlay(card);

    try {
      let v = variants[card.dataset.handle];
      if (!v) {
        await ready;
        v = variants[card.dataset.handle];
      }
      if (!v) {
        const r = await fetch('/products/' + card.dataset.handle + '.js');
        if (!r.ok) throw new Error('product');
        const p = await r.json();
        const pv = p.variants && p.variants[0];
        if (pv) v = { id: pv.id, available: pv.available };
      }
      if (!v || !v.available) throw new Error('available');
      if (window.TitanFX) {
        hideOverlay();
        await window.TitanFX.playOne({
          title: card.dataset.fruit,
          image: card.dataset.img || (card.querySelector('.tlf2-art img') || {}).src,
          mxn: Number(card.dataset.mxn) || 0,
          qty: 1,
          sub: 'Se entrega a ' + user
        });
        overlay(card);
      }
      post(v.id, card, user);
    } catch (err) {
      hideOverlay();
      status.textContent = err.message === 'available'
        ? 'Este artículo está agotado por ahora. Escríbenos por Discord.'
        : 'No pudimos preparar el pago. Revisa tu conexión e inténtalo de nuevo.';
      btn.disabled = false;
      btn.classList.remove('tg-busy');
      btn.textContent = 'Comprar ahora';
    }
  }, true);

  // ---- Agregar al carrito (debajo de "Comprar ahora") ----
  function validate(modal) {
    const status = modal.querySelector('.tlf2-status');
    const input = modal.querySelector('#tlf2-username');
    const confirm = modal.querySelector('#tlf2-confirm');
    const user = (input.value || '').trim();
    if (user.length < 3) { status.textContent = 'Escribe un usuario de Roblox válido.'; input.focus(); return null; }
    if (!confirm.checked) { status.textContent = 'Confirma que el usuario es correcto.'; return null; }
    status.textContent = '';
    return user;
  }

  async function variantFor(card) {
    let v = variants[card.dataset.handle];
    if (!v) { await ready; v = variants[card.dataset.handle]; }
    if (!v) {
      const r = await fetch('/products/' + card.dataset.handle + '.js');
      if (!r.ok) throw new Error('product');
      const p = await r.json();
      const pv = p.variants && p.variants[0];
      if (pv) v = { id: pv.id, available: pv.available };
    }
    if (!v || !v.available) throw new Error('available');
    return v;
  }

  function toast(text) {
    let t = document.getElementById('titan-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'titan-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.textContent = text;
    t.classList.remove('on');
    void t.offsetWidth;
    t.classList.add('on');
    clearTimeout(t._h);
    t._h = setTimeout(() => t.classList.remove('on'), 2600);
  }

  const CART_LABEL = '<span class="tg-cart-ico" aria-hidden="true"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2.5 3h2.6l2.4 12.2a1.5 1.5 0 0 0 1.5 1.2h8.9a1.5 1.5 0 0 0 1.5-1.1L21.5 8H6"/></svg></span><span class="tg-cart-txt">Agregar al carrito</span>';

  function injectCartButton() {
    const buy = document.querySelector('#tlf2-modal .tlf2-checkout');
    if (!buy || document.querySelector('#tlf2-modal .tg-addcart')) return;
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'tg-addcart';
    b.innerHTML = CART_LABEL;
    buy.insertAdjacentElement('afterend', b);
  }
  if (document.readyState === 'complete') injectCartButton();
  else document.addEventListener('DOMContentLoaded', injectCartButton);

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest && e.target.closest('#tlf2-modal .tg-addcart');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    const modal = document.getElementById('tlf2-modal');
    const status = modal.querySelector('.tlf2-status');
    const card = lastCard;
    if (!card) return;
    const user = validate(modal);
    if (!user) return;

    btn.disabled = true;
    btn.classList.add('tg-busy');
    btn.querySelector('.tg-cart-txt').textContent = 'Agregando…';
    const drawerEl = document.querySelector('cart-drawer');

    try {
      const v = await variantFor(card);
      const body = {
        items: [{
          id: v.id,
          quantity: 1,
          properties: {
            'Usuario exacto de Roblox': user,
            'Artículo seleccionado': card.dataset.fruit,
            'Método de entrega': card.dataset.method === 'trade' ? 'Intercambio dentro del juego' : 'Gifting manual',
          },
        }],
      };
      if (drawerEl && drawerEl.getSectionsToRender) {
        body.sections = drawerEl.getSectionsToRender().map((s) => s.id).join(',');
        body.sections_url = window.location.pathname;
      }
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await r.json();
      if (!r.ok || data.status) throw new Error(data.description || 'cart');

      btn.classList.remove('tg-busy');
      btn.classList.add('tg-done');
      btn.querySelector('.tg-cart-txt').textContent = '¡Agregado!';
      toast(card.dataset.fruit + ' se agregó al carrito');
      if (window.TitanFX) {
        var art = document.querySelector('#tlf2-modal .tlf2-model img, #tlf2-modal .tlf2-viewer img') || card.querySelector('.tlf2-art img');
        window.TitanFX.flyToCart(art, card.dataset.img || (art && art.src));
      }

      setTimeout(() => {
        const close = modal.querySelector('.tlf2-close');
        if (close) close.click();
        if (drawerEl && data.sections && drawerEl.renderContents) {
          drawerEl.classList.remove('is-empty');
          drawerEl.renderContents(data);
        } else if (!drawerEl) {
          window.location.href = '/cart';
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'titan-modal', cartData: data });
        }
        btn.disabled = false;
        btn.classList.remove('tg-done');
        btn.querySelector('.tg-cart-txt').textContent = 'Agregar al carrito';
      }, 650);
    } catch (err) {
      status.textContent = err.message === 'available'
        ? 'Este artículo está agotado por ahora. Escríbenos por Discord.'
        : 'No pudimos agregarlo al carrito. Inténtalo de nuevo.';
      btn.disabled = false;
      btn.classList.remove('tg-busy');
      btn.querySelector('.tg-cart-txt').textContent = 'Agregar al carrito';
    }
  }, true);

  // Al abrir otra fruta, reiniciar el botón
  document.addEventListener('click', (e) => {
    if (!(e.target.closest && e.target.closest('.tlf2-card[data-handle]'))) return;
    const b = document.querySelector('#tlf2-modal .tg-addcart');
    if (b) { b.disabled = false; b.classList.remove('tg-busy', 'tg-done'); b.querySelector('.tg-cart-txt').textContent = 'Agregar al carrito'; }
  });

  // Si el cliente regresa con el botón "atrás", quitar la pantalla de carga
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    hideOverlay();
    const b = document.querySelector('#tlf2-modal .tlf2-checkout');
    if (b) { b.disabled = false; b.classList.remove('tg-busy'); b.textContent = 'Comprar ahora'; }
  });
})();
